import React, { useState, useEffect } from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import axios from 'axios';
import QRCode from "react-qr-code";
import { LinearProgress } from '@mui/material';
const { Buffer } = require('buffer');

const HOST = process.env.REACT_APP_APIHOST || 'https://knmi.ruijs.fr';
const MAX_DATE = process.env.REACT_APP_MAX_DATE || "2025-04-05";
const MIN_DATE = process.env.REACT_APP_MIN_DATE || "1901-01-01";
console.log(HOST)
const BarcodeGenerator = () => {
    const [name, setName] = useState('');
    const [birthday, setBirthday] = useState('');
    const [blobURL, setBlobURL] = useState(null);
    const [qrURL, setQRURL] = useState(null);
    const [error, setError] = useState(null);
    const [show, setShow] = useState(null)
    const [maxDate, setMaxDate] = useState(null)
    const [minDate, setMinDate] = useState(null)

    useEffect(() => {
        const fetchDate = async () => {
            try {
                const response = await axios.get(`${HOST}/health`);
                setMaxDate(response.dataset.to);
                setMinDate(response.dataset.from)
            } catch (error) {
                console.error("Error fetching date:", error);
                setMaxDate(MAX_DATE);
                setMinDate(MIN_DATE);
            }
        };

        fetchDate();
    }, []);

    const handleSubmit = async (e) => {
        setShow(true)
        e.preventDefault();
        try {
            const response = await axios.post(
                `${HOST}/streepjescode`,
                {
                    name: name,
                    birthday: birthday
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'accept': 'application/json'
                    },

                    //responseType: 'arraybuffer' // to handle binary response
                }
            );
            //const blob = new Blob([response.data], { type: 'image/png' });


            //const byteCharacters = atob(response.data.blob);
            console.log(response.data.blob)
            const binaryData = Buffer.from(response.data.blob, 'base64');
            console.log(binaryData)
            const blob = new Blob([binaryData], { type: 'image/png' });
            const imageBlobUrl = URL.createObjectURL(blob);

            setQRURL(`${HOST}/klimaatstreepjes/${name}/${birthday}`)

            /*if (response.data.filename != null) {
                 setQRURL(`${HOST}/streepjescode/${response.data.filename}`)
             }
*/
            setBlobURL(imageBlobUrl);
            setError(null);
        } catch (error) {
            setError(error.message);
            setBlobURL(null);
        }
        setShow(false)
    };

    const header = (<div className="wrapper relative" id="header">
        <div className="site-header__logowrp">
            <a href="/home">
                <img src="https://cdn.knmi.nl/assets/logo_large-1eaabc639fd87bd3867e4e1e3358711968aad57ca90d766ecdd62f93930abf3b.png"
                    className="site-header__logo large"
                    alt="Logo Koninklijk Nederlands Meteorologisch Instituut | Ministerie van Infrastructuur en Waterstaat" />
                <img src="https://cdn.knmi.nl/assets/logo_small-556afeb8156445792163b9ba156bf49ce4c40c52f370409f9fb6b924b68218c4.png"
                    className="site-header__logo small"
                    alt="Logo Koninklijk Nederlands Meteorologisch Instituut | Ministerie van Infrastructuur en Waterstaat" />
                <noscript>
                    <img className="site-header__logo" width="230" height="79" alt="Logo KNMI"
                        src="https://cdn.knmi.nl/assets/logo_large-1eaabc639fd87bd3867e4e1e3358711968aad57ca90d766ecdd62f93930abf3b.png" />
                </noscript>
            </a>
        </div>
    </div>);
    console.log(window.location.hostname);
    return (<div>
        {
            window.location.hostname !== 'klimaatstreepjes.ruijs.fr' && header
        }
        <div className="wrapper--navbar">
            <div className="main-navbar">
            </div>
            <div className="main-navbar__sub">
                <div style={{ 'padding': '1px' }}>

                    <div style={{ float: 'right', paddingRight: '10px' }}>
                         { qrURL && <QRCode value={qrURL} /> }
                        {show && <Box id="progress" sx={{ display: 'flex' }}>
                            <CircularProgress />
                        </Box>
                        }
                    </div>
                    <div>
                        <form onSubmit={handleSubmit}>
                            <ul style={{ listStyleType: 'none' }}>
                                <li style={{ 'paddingBottom': '10px' }}>
                                    <label>
                                        Naam:&nbsp;
                                        <input
                                            pattern="[a-zA-Z-]+"
                                            type="text"
                                            value={name}
                                            onChange={(e) => {
                                                setName(e.target.value)
                                                setBlobURL(null)
                                                setQRURL(null)
                                            }} />
                                    </label>
                                </li>
                                <li style={{ 'paddingBottom': '10px' }}>

                                    {!maxDate && <LinearProgress /> ||
                                        <label title={`max date: ${maxDate}`}>
                                            Geboortedatum:&nbsp;
                                            <input type={"date"}
                                                min={minDate}
                                                max={maxDate}
                                                value={birthday}
                                                onChange={(e) => {
                                                    setBirthday(e.target.value);
                                                    setBlobURL(null)
                                                    setQRURL(null)
                                                }} />
                                        </label>
                                    }
                                </li>
                                {
                                    !blobURL && <li style={{ 'paddingBottom': '10px' }}>
                                        <button
                                            className="btn"
                                            type="submit">Bereken jouw klimaatstreepjes</button>
                                    </li>}

                                {
                                    blobURL && <li style={{ 'paddingBottom': '10px' }}>
                                        <a
                                            target="_blank"
                                            className="btn"
                                            href={`${HOST}/klimaatstreepjes/${name}/${birthday}`}
                                        >download</a></li>
                                }
                            </ul>

                        </form>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        {error && <p>Error: {error}</p>}
                        {blobURL && <img style={{ width: '100%' }} src={blobURL} alt="image" />}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
};

export default BarcodeGenerator;
